import { BasketItem, ViewItem } from '@easterngraphics/wcf/modules/bsk';
import { ArticleElement} from '@easterngraphics/wcf/modules/cf';

/**
 * This function return all basket item ids for each item in the list. However,
 * the ids of child items are not included.
 */
export function *getAllBasketIds(items: Iterable<ArticleElement | ViewItem | BasketItem>): IterableIterator<string> {
    for (const item of items) {
        if (item instanceof ArticleElement && item.basketId != null) {
            yield item.basketId;
        }

        if (item instanceof ViewItem) {
            for (const basketItem of item.getBasketItems()) {
                yield basketItem.id;
            }
        }

        if (item instanceof BasketItem) {
            yield item.id;
        }
    }
}
